// @ts-nocheck
/* eslint-disable react/prop-types */
/**
 * DashedEdge — Curved dashed line edge.
 *
 * Renders a bezier path with stroke-dasharray for a dashed appearance.
 *
 * Supports:
 *   data.color       — stroke colour override (theme tokens supported)
 *   data.dashArray   — custom dash pattern
 *   animated         — animates the dashed stroke when true
 *   markerEnd        — end arrow marker
 *   markerStart      — start arrow marker (for bidirectional)
 */
import React, { memo } from 'react';
import { BaseEdge, getBezierPath } from 'reactflow';
import { useTheme } from '@mui/material/styles';
import { resolveThemeColor } from '../shared/themeColorUtils';

const DashedEdge = memo(
  ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    markerEnd,
    markerStart,
    animated = false,
    data,
  }) => {
    const theme = useTheme();
    const [edgePath] = getBezierPath({
      sourceX,
      sourceY,
      sourcePosition,
      targetX,
      targetY,
      targetPosition,
    });

    const strokeColor = resolveThemeColor(
      theme,
      data?.color,
      'solyticsFlow.edge.mutedStroke'
    );
    const dashArray = data?.dashArray || '6 4';

    return (
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        markerStart={markerStart}
        style={{
          stroke: strokeColor || theme.palette.text.primary,
          strokeWidth: 1.5,
          strokeDasharray: dashArray,
          animation: animated ? 'dashdraw 0.5s linear infinite' : undefined,
        }}
      />
    );
  }
);
DashedEdge.displayName = 'DashedEdge';

export default DashedEdge;
